// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__RyETE","unreadBadge":"styles_unreadBadge__3Y6ZQ","modalContent":"styles_modalContent__3crzo","modal":"styles_modal__33U29"};